import { render } from "./TagInfoModal.vue?vue&type=template&id=0f6f5df9&scoped=true"
import script from "./TagInfoModal.vue?vue&type=script&lang=js"
export * from "./TagInfoModal.vue?vue&type=script&lang=js"

import "./TagInfoModal.vue?vue&type=style&index=0&id=0f6f5df9&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6f5df9"]])

export default __exports__